import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';

export const StartRentalButtonScreenshot = () => (
    <div className='pointer-events-none user-select-none padding-15 bg-lighter'>
        <Button bsStyle='primary' iconName='rioglyph-ok-dashed'>
            <FormattedMessage id='intl-msg:rental-web.dialog.start-rental.button.title' />
        </Button>
    </div>
);
